<template>
  <div class="simple-card" style="background-color: #F8F8F8">
    <h3 class="simple-card-title" style="margin: 0">{{$t('pages.adminpanel.ratingStatistics.group')}}</h3>
   
              <h5>{{$t('pages.adminpanel.ratingStatistics.userRatings')}}</h5>
             
                  <Bar style="height: 20em" class="" :height="125" :chartData="{labels: ratingHistogramX,
                    datasets: [{label: $t('pages.adminpanel.ratingStatistics.numberOfStudents'), backgroundColor: ratingHistogramBarve, data: ratingHistogramY}]}"
                       :options="{maintainAspectRatio: false, responsive: true, scales: {xAxes: [{stacked: true, barPercentage: '1',  categoryPercentage: '0.9'}], yAxes: [{stacked: true}]}}"></Bar>
  </div>
</template>
<script>
import Line from '@/charts/Line'
import Bar from '@/charts/Bar.js'
export default {
  name: 'histogram',
  components: {'line-chart': Line, Bar},
  props: ['histogram', 'rating'],
  data () {
    return {
      ratingHistogramX: [],
      ratingHistogramY: [],
      ratingHistogramBarve: []
    }
  },
  created () {
    this.pripraviHistogram()
  },
  methods: {
    ratingToHistogramGroup (rating) {
      let spodnjaMeja = Math.floor(rating / 100) * 100
      return spodnjaMeja + '-' + (spodnjaMeja + 99)
    },
    pripraviHistogram () {
      this.ratingHistogramX = []
      this.ratingHistogramY = []
      this.ratingHistogramBarve = []

      let spodnjaMeja = 100
      let zgornjaMeja = 1900

      for (let ratingBorder = 100; ratingBorder < 1900; ratingBorder += 100) {
        let imeSkupine = this.ratingToHistogramGroup(ratingBorder)
        if (this.histogram[imeSkupine] !== undefined) {
          if (ratingBorder < spodnjaMeja) {
            spodnjaMeja = ratingBorder
          }
          if (ratingBorder > zgornjaMeja) {
            zgornjaMeja = ratingBorder
          }
        }
      }

      let padding = Math.max((100 - (zgornjaMeja - spodnjaMeja)) / 2, 10)

      for (let ratingBorder = Math.round((spodnjaMeja - padding) / 100) * 100; ratingBorder <= zgornjaMeja + padding; ratingBorder += 100) {
        let imeSkupine = this.ratingToHistogramGroup(ratingBorder)
        this.ratingHistogramX.push(imeSkupine)
        if (this.histogram[imeSkupine] !== undefined) {
          this.ratingHistogramY.push(this.histogram[imeSkupine])
        } else {
          this.ratingHistogramY.push(0)
        }
        if (this.ratingToHistogramGroup(this.rating) === imeSkupine) {
          this.ratingHistogramBarve.push('#ca262b')
        } else {
          this.ratingHistogramBarve.push('#2872ca')
        }
      }
    }
  }
}

</script>

<style scoped lang="scss">
@import '../../../assets/k6styles/cards';

.simple-card {
  margin: 30px 0;
}

</style>


// WEBPACK FOOTER //
// Histogram.vue?44e9d012